import { useTranslation } from 'react-i18next';
import type { IRecordTypeDefinition } from '@platform/core/types';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';

/**
 * Підказка порожньої назви (UIUX field-types/title; прототип v4 fTitlePh «Untitled task» → «Завдання без назви»): назва типу однини —
 * як є (uk: «{{type}} без назви») або малими літерами (en: «Untitled {{typeLower}}»).
 */
export function useTitlePlaceholder(rt: Pick<IRecordTypeDefinition, 'key' | 'singular' | 'name'>): string {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const type = strings.entity(rt.key, 'singular', rt.singular ?? rt.name);
  return t('recordPage.titlePlaceholder', { type, typeLower: type.toLocaleLowerCase() });
}
